// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Q1nl","col":"styles_col__2iLG0"};